/** Named brand packs — recreate CRM-adjacent looks without copying CRM CSS. */

export type BrandPackId = "classic" | "slate" | "teal";

export type BrandPack = {
  id: BrandPackId;
  labelKey: "settings.brandClassic" | "settings.brandSlate" | "settings.brandTeal";
  brand: string;
  brandHover: string;
  soft: string;
};

export const BRAND_PACKS: Record<BrandPackId, BrandPack> = {
  classic: {
    id: "classic",
    labelKey: "settings.brandClassic",
    brand: "#002FA7",
    brandHover: "#001B66",
    soft: "rgba(0, 47, 167, 0.10)",
  },
  slate: {
    id: "slate",
    labelKey: "settings.brandSlate",
    brand: "#3730A3",
    brandHover: "#312E81",
    soft: "rgba(55, 48, 163, 0.10)",
  },
  teal: {
    id: "teal",
    labelKey: "settings.brandTeal",
    brand: "#0F766E",
    brandHover: "#115E59",
    soft: "rgba(15, 118, 110, 0.12)",
  },
};

export function applyBrandPack(id: BrandPackId) {
  const pack = BRAND_PACKS[id] || BRAND_PACKS.classic;
  const root = document.documentElement;
  root.dataset.brand = pack.id;
  root.style.setProperty("--amos-brand", pack.brand);
  root.style.setProperty("--amos-brand-hover", pack.brandHover);
  root.style.setProperty("--amos-brand-soft", pack.soft);
  root.style.setProperty("--color-brand-500", pack.brand);
  root.style.setProperty("--color-brand-600", pack.brand);
  root.style.setProperty("--color-brand-700", pack.brandHover);
}
